import $ from 'jquery';

import { whatInput } from 'what-input';
import { Foundation } from './lib/foundation';

import { ImagesReveal } from './lib/app.imagesReveal';

// Load Foundation on the whole document
$(document).foundation();

// Catch images which can be opened into a modal
let imagesReveal = new ImagesReveal($('#content img').parent('a'));



// WEBPACK FOOTER //
// ./src/js/app.js